import React from "react";

import classnames from "classnames";
import BoltIcon from "Intuit/BoltIcon";
import HarmonyIcon from "Intuit/HarmonyIcon";
import isIntuit from "Intuit/isIntuit";
import { isTrowserRollout } from "Intuit/TrowserUtils";

import Icon from "Common/Icon";

import makeBem from "Utils/makeBem";

type Props = {};
const bem = makeBem("RemoveIcon");

const RemoveIcon = ({ ...rest }: Props) => {
  let icon;

  if (!isIntuit()) {
    icon = <Icon className={bem()} icon="times" flavor="solid" {...rest} />;
  } else if (isTrowserRollout()) {
    icon = <BoltIcon icon="delete" {...rest} />;
  } else {
    icon = (
      <HarmonyIcon
        icon="close"
        className={classnames(bem(), {
          [bem(null, "intuit")]: true,
        })}
        {...rest}
      />
    );
  }

  return icon;
};

export default RemoveIcon;
